import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../services/base-component.service'

@Component({
  selector: 'gpa-home',
  templateUrl: './home.component.html',
  providers: [BaseComponentService]
})

export class HomeComponent extends BaseComponentService implements OnInit {
  projetoIntegrado: string;

  ngOnInit() {

    if (sessionStorage.getItem('ProjetoIntegrado') == null) {
      this.getProjetoIntegrado();
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts